module.exports = __webpack_public_path__ + "img/question-red.4a7fd3c.svg";